import { render, staticRenderFns } from "./WizardNotes.vue?vue&type=template&id=1f83b8b6"
import script from "./WizardNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardNotes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports